<template>
  <div class="evaluaDetail">
    <div class="evalde_center">
      <!-- 面包屑 -->
      <div class="major_dh">
        <div class="majorleft">
          <p class="xian_lf"></p>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
              ><span class="bread_one" @click="zcrouter"
                >职业测评</span
              ></el-breadcrumb-item
            >
            <el-breadcrumb-item
              ><span class="bread_one">内容详情</span></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>
      <!-- 内容 -->
      <div v-if="cepview == 0">
        <div class="eval_neir" v-if="evaldetail == null">
          <el-empty description="加载中..."></el-empty>
        </div>
        <div class="eval_neir" v-else>
          <div class="eval_title">
            <h3>{{ evaldetail.title }}</h3>
          </div>
          <div class="evalnr_center">
            <p v-html="evaldetail.introduction"></p>
          </div>
          <div class="yesbtns" >
            <el-checkbox v-model="checked" v-if="mydeta == null">测评结果仅供参考，不作为评判依据</el-checkbox>
            <div class="yesbtns_start" >
              <el-button v-if="mydeta == null" class="bgbtn" @click="startcep" type="primary"
                >{{indresult == 1?'重新测评':'开始测评'}}</el-button
              >
              <el-button v-if="indresult == 1" @click="reultopget">我的结果</el-button>
            </div>
          </div>
          <!-- <div class="btnceppls">
            <el-button v-if="indresult == 1" @click="reultopget">我的结果</el-button>
          </div>
          <div class="btnlistall" v-if="mydeta == null">
            <el-button
              class="bgbtn"
              v-if="indresult == 1"
              type="primary"
              style="background-color: #1d4434; border: 1px solid #1d4434"
              @click="chongxincep"
              >重新测评</el-button
            >
            <el-button v-if="indresult == 1" @click="reultopget">我的结果</el-button>
          </div> -->
          
        </div>
      </div>
      <div v-if="cepview == 1">
        <div class="eval_neir2" v-if="evaldetail == null"></div>
        <div class="eval_neir2" v-else>
          <div class="eval_title">
            <h3>{{ evaldetail.title }}</h3>
          </div>
          <div class="evalnr_center">
            <timuType :evaldetail="evaldetail"></timuType>
          </div>
          <div class="yesbtns">
            <el-button class="bgbtn" :loading="cepokload" @click="xuanxbtn" type="primary"
              >完成测评</el-button
            >
          </div>
        </div>
      </div>
      <div v-if="cepview == 2">
        <div class="eval_result">
          <div
            class="eval_liol"
            style="text-align: center"
            v-if="quizResul == null"
          ></div>
          <div class="eval_liol" v-else>
            <el-scrollbar style="height: 100%">
              <div class="eval_top1">
                <p><span class="eval_colors">测评时间：</span> {{ stardata }}</p>
                <p><span class="eval_colors">测评标题：</span> {{ quizResul.title }}</p>
                <p>
                  <span class="eval_colors">测评类型：</span> {{ quizResul.typeName }}
                </p>
              </div>
              <el-divider></el-divider>
              <div
                class="eval_top2"
                v-for="(itemc, indexc) in quizResul.quizConclusionList"
                :key="indexc"
              >
                <p>
                  <span class="eval_colors">测评结论：</span>
                  <span class="jielun_yell">{{ itemc.title }}</span>
                </p>
                <p><span class="eval_colors">测评分值：</span> {{ itemc.score }}</p>
                <p><span class="eval_colors">测评评语：</span></p>
                <p class="commpyop">{{ itemc.comment }}</p>
                <el-divider></el-divider>
              </div>
            </el-scrollbar>
          </div>
          <div class="botcaozuo" v-if="quizResul !== null">
            <div class="weix_list">
              <p class="pjtxtsl">评价：</p>
              <div class="wexitem" @click="pingjiaos(0)">
                <img v-if="evaluate == 0" src="../../assets/images/smile.png" alt="" />
                <img v-else src="../../assets/images/smileNo.png" alt="" />
                <span>很准 </span>
              </div>
              <div class="wexitem" @click="pingjiaos(1)">
                <img v-if="evaluate == 1" src="../../assets/images/kind.png" alt="" />
                <img v-else src="../../assets/images/kindNo.png" alt="" />
                <span>一般 </span>
              </div>
              <div class="wexitem" @click="pingjiaos(2)">
                <img v-if="evaluate == 2" src="../../assets/images/sad.png" alt="" />
                <img v-else src="../../assets/images/sadNo.png" alt="" />
                <span>不准 </span>
              </div>
              <div class="downLoad">
                <el-button
                  class="bgbtn"
                  style="background-color: #1d4434; border: 1px solid #1d4434"
                  type="primary"
                  @click="chongxincep2"
                  >重新测评</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  careerQuizDetails,
  careerQuizover,
  careerQuizPingjia,
  getresult,
} from "@/api/evaluating";
import timuType from "../../components/timuType";
import { timezhuan } from "@/utils/index";
export default {
  name: "evaluaDetail",
  data() {
    return {
      id: "",
      evaldetail: null,
      checked: false,
      cepview: 0,
      quizResul: null, //完成测评后的结果
      careeTypeList: [],
      mydeta: null,
      evaluate: null,
      indresult: 0,
      cepokload: false,
      stardata: "",
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.careedetailget(this.id);
    }
    if (this.$route.query.mydeta) {
      this.mydeta = this.$route.query.mydeta;
      //0代表我的测评来的  1代表我的结果来的
    }
    if (this.$route.query.tabindex && this.$route.query.tabindex.indexOf(0) > -1) {
      this.$store.commit("user/SET_TABINDEX", this.$route.query.tabindex);
    } else {
      this.$store.commit("user/SET_TABINDEX", Number(this.$route.query.tabindex));
    }
    this.indresult = this.$route.query.indresult;
  },
  filters: {
    timezhuan,
  },
  components: { timuType },
  mounted() {},
  methods: {
    careedetailget(id) {
      careerQuizDetails(id).then((res) => {
        if (res.code == 200) {
          this.evaldetail = res.data;
          if (this.mydeta == 1) {
            this.reultopget();
            this.cepview = 2;
          }
        }
      });
    },
    // 开始测评
    startcep() {
      if (this.checked) {
        this.cepview = 1;
        this.toTop();
      } else {
        this.$message({
          message: "请先同意此声明",
          type: "warning",
        });
      }
    },
    //首页的重新测评
    chongxincep() {
      this.reultchongxin();
    },
    //结果页的重新测评
    chongxincep2() {
      this.cepview = 0;
      this.indresult = 0;
      this.mydeta = null;
      this.$router.push({
        path: "/evaluaDetail",
        query: {
          id: this.id,
          tabindex: this.$store.state.user.tabindex,
          indresult: 0,
        },
      });
      this.careedetailget(this.id);
      this.toTop();
    },
    //查询测评结果
    reultchongxin() {
      let parmas = {
        quizId: this.evaldetail.quizConclusionList[0].quizId, //测评id
      };
      getresult(parmas).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.cepview = 1;
          } else {
            this.$message({
              message: "您还未进行测评",
              type: "warning",
            });
          }
        }
      });
    },
    //提交题目选择
    xuanxbtn() {
      var answstatus = false;
      for (let index = 0; index < this.evaldetail.quList.length; index++) {
        let answList = this.evaldetail.quList[index].answerList;
        for (let index2 = 0; index2 < answList.length; index2++) {
          if (answList[index2].isChoose == true) {
            answstatus = true;
          }
        }
      }

      if (answstatus == false) {
        this.$message({
          message: "请选择题目",
          type: "warning",
        });
        return;
      }
      this.cepokload = true;
      this.evaldetail.userId = this.$store.getters.userId;
      careerQuizover(this.evaldetail)
        .then((res) => {
          if (res.code == 200) {
            this.quizResul = res.data;
            this.stardata = res.data.startDate;
            this.cepview = 2;
            this.toTop();
          }
          this.cepokload = false;
        })
        .catch((err) => {
          this.cepokload = false;
        });
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    //评价
    pingjiaos(evaluate) {
      if (this.evaluate == evaluate) {
        this.$message({
          message: "请勿重复评价",
          type: "warning",
        });
        return;
      }
      this.evaluate = evaluate;
      let data = {
        quizId: this.quizResul.quizConclusionList[0].quizId, //测评id
        evaluate: evaluate, //结果评价 0很好 1一般 2不准
      };
      careerQuizPingjia(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "评价成功",
            type: "success",
          });
        }
      });
    },
    //查询测评结果
    reultopget() {
      let parmas = {
        quizId: this.evaldetail.quizConclusionList[0].quizId, //测评id
      };
      getresult(parmas).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.evaluate = res.data.evaluate;
            this.quizResul = res.data.result;
            this.stardata = res.data.startDate;

            this.cepview = 2;
          } else {
            this.$message({
              message: "您还未进行测评",
              type: "warning",
            });
          }
        }
      });
    },
    // 跳转
    zcrouter() {
      this.$router.push({
        path: "/evaluating",
        query: {
          navId: 54,
          childtype: 68,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.evaluaDetail {
  width: 100%;
  min-height: 1000px;
  background-color: #f7f7f7;
  overflow: hidden;
  .evalde_center {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .major_dh {
      height: 30px;
      overflow: hidden;
      position: relative;
      margin: 10px 0;
      .majorleft {
        float: left;
        margin: 8px 0 0 20px;
        display: flex;

        .bread_one {
          font-size: 18px;
        }
      }
      .xian_lf {
        display: inline-block;
        width: 10px;
        height: 30px;
        background: #1d4434;
        position: absolute;
        left: 0;
        top: 4px;
      }
    }
    // 内容1
    .eval_neir {
      width: 100%;
      min-height: 930px;
      margin: 10px auto;
      background-color: #fff;
      overflow: hidden;
      .eval_title {
        text-align: center;
        padding: 35px 0;
      }
      .evalnr_center {
        width: 100%;
        min-height: 300px;
        padding: 0 30px;
        letter-spacing: 2px;
      }
      .yesbtns {
        padding: 20px 0;
        text-align: center;
        .yesbtns_start {
          margin: 20px 0 0 0;
          .bgbtn {
            background-color: #1d4434;
            border: 1px solid #1d4434;
          }
        }
      }
      .btnlistall {
        width: 350px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .bgbtn {
          background-color: #1d4434;
          border: 1px solid #1d4434;
        }
      }
      .btnceppls {
        text-align: center;
        padding: 20px 0;
      }
    }
    //内容2
    .eval_neir2 {
      width: 100%;
      min-height: 900px;
      margin: 10px auto;
      background-color: #fff;
      overflow: hidden;
      .eval_title {
        text-align: center;
        padding: 35px 0;
      }
      .evalnr_center {
        width: 100%;
        min-height: 750px;
        padding: 30px;
        letter-spacing: 2px;
      }
      .yesbtns {
        padding: 20px 0;
        text-align: center;
        .bgbtn {
          background-color: #1d4434;
          border: 1px solid #1d4434;
        }
      }
    }
    // 测评结果
    .eval_result {
      width: 100%;

      margin: 10px auto;
      background-color: #fff;
      overflow: hidden;
      padding: 30px;
      color: #555555;
      position: relative;

      .eval_liol {
        width: 100%;
        height: 750px;

        ::v-deep .el-scrollbar__wrap {
          overflow-x: hidden;
        }
        .eval_top1 {
          p {
            margin-top: 15px;
            .eval_colors {
              color: #1d4434;
              font-weight: bold;
            }
            .jielun_yell {
              color: #B18227;
            }
          }
        }
        .eval_top2 {
          p {
            margin-top: 15px;
            font-size: 16px;
            color: #555555;
            line-height: 1.8;
            letter-spacing: 1px;
            .eval_colors {
              color: #1d4434;
              font-weight: bold;
            }
            .jielun_yell {
              color: #B18227;
            }
          }
          .commpyop {
            white-space: pre-wrap;
          }
        }
      }
      .botcaozuo {
        width: 100%;
        height: 50px;
        padding: 10px 30px;

        .weix_list {
          display: flex;
          margin-top: 15px;
          margin-left: -20px;
          .pjtxtsl {
            margin: 7px 0 0 0;
          }
          .wexitem {
            display: flex;
            margin: 5px 0 0 20px;
            cursor: pointer;
            img {
              width: 26px;
              height: 26px;
              vertical-align: middle;
            }
            span {
              line-height: 25px;
              margin-left: 5px;
              font-size: 15px;
            }
          }
          .downLoad {
            margin-left: 30px;
          }
        }
      }
    }
  }
}
</style>
